import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { QuestionBase } from './question-base';

@Injectable()
export class QuestionControlService {
  toFormGroup(questions: QuestionBase<any>[]) {
    const group = {};
    questions.forEach(question => group[question.key] = this.toFormControl(question));

    return new FormGroup(group);
  }

  toFormControl(question: QuestionBase<any>): FormControl {
    const formState = {
      value: question.value || '',
      disabled: question.disabled
    };
    const validator = question.required ? Validators.required : null;

    return new FormControl(formState, validator);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/dynamic-form/shared/question-control.service.ts